import {getId} from 'apis/model/base'
import {ROOT_URL} from 'envs/_current/config'
import getLinkToDetail from 'helpers/getLinkToDetail'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import createStickySider from 'views/AppLocals/factory/createStickySider'
import {FollowButton} from '../../../../components/Feed/FollowButton'
import useTranslate from '../../../../modules/local/useTranslate'
import UserContext from '../UserContext'
import UserChannels from './UserChannels'
import UserOrganizations from './UserOrganizations'
import {Avatar, Image} from "antd";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {Link} from "react-router-dom";
import {WrapperBlockSider} from "../../Organization/components/WrapperBlockSider";
import {
    channel_getChannelsByUser_Api,
    channel_getSummaryChannelArticle_Api,
    game_getPreviewQuestion_Api,
    organization_getOrganizationsByUser_Api
} from "../../../../apis";
import {renderLoading} from "../../functions/renderers/renderLoading";
import {bindQueryParam} from "../../functions/routerHelper";
import {BiSolidChurch} from "react-icons/bi";
import getAvatar from "../../../../helpers/getAvatar";
import getTitle from "../../../../helpers/getTitle";
import {OrgType} from "../../Organization/components/OrgType";
import CustomLazyPaginationWrapper from "../../../../modules/asyncCache/components/CustomLazyPaginationWrapper";
import {renderShowMore} from "../../../MainPage/functions/renderLimitLoadMore";
import {RiSignalTowerFill} from "react-icons/ri";
import useAsync from "../../../../modules/asyncCache/useAsync";
import {getResponseItems} from "../../../Shared";
import {ImagePlaceholder} from "../../../../conts/imageBase64";
import {ChurchScenePlaceholder} from "../../../../components/Svgs/CatholicPlaceholderSvg";
import Toggle from "../../../../components/Toggle";
import _ from "lodash";
import {QuizPreviewCard} from "../../Game/components/GamesPromoBlock";
import {GoDotFill} from "react-icons/go";


const ChannelItemCompact = ({item}) => {
    const t = useTranslate()
    if (!item) return null
    return (
        <div
            className="px-3 py-2 flex items-center gap-3 hover:background-200 cursor-pointer transition-all duration-300">
            <Avatar
                size={44}
                icon={<RiSignalTowerFill size={20} className="text-blue-500"/>}
                src={getAvatar(item)}
                className="flex flex-center bg-blue-50 rounded-full flex-shrink-0"
            />
            <div className="flex flex-col flex-1 min-w-0">
                <Link
                    to={getLinkToDetail(item)}
                    className="font-semibold text-sm no-underline leading-snug truncate">
                    {getTitle(item)}
                </Link>
                {item.total_followers > 0 && (
                    <span className="text-2xs text-color-400 truncate">
                        {Number(item.total_followers).toLocaleString()} {t('followers')}
                    </span>
                )}
            </div>
            <FollowButton
                size="small"
                item={item}
            />
        </div>
    )
}

export const Channels = () => {
    const t = useTranslate()
    const {user} = useContext(UserContext)
    const apiInfo = channel_getChannelsByUser_Api
    const refreshKey = useMemo(
        () => [apiInfo.path.replace(':id', user?.id)].join('/'),
        [user?.id]
    )
    const [limit, setLimit] = useState(3)

    return (
        <UserChannels
            user_id={getId(user)}
            renderWrap={(child, __, count) =>
                count > 0 && (
                    <WrapperBlockSider
                        flat={true}
                        title="channels">
                        <div className="flex flex-col gap-1">
                            <CustomLazyPaginationWrapper
                                sample={limit}
                                auto={true}
                                key={refreshKey}
                                apiInfo={apiInfo}
                                renderLoading={renderLoading}
                                renderItem={(item) => <ChannelItemCompact item={item} key={getId(item)}/>}
                                query={bindQueryParam({id: user?.id})}
                                renderLoadMoreButton={
                                    renderShowMore(
                                        [limit, setLimit],
                                        {
                                            buttonClassName: 'my-2 font-medium text-xs text-secondary-500 hover:text-secondary-700'
                                        }
                                    )
                                }
                            />
                        </div>
                    </WrapperBlockSider>
                )
            }
        />
    )
}

export const Organizations = () => {
    const t = useTranslate()
    const {user} = useContext(UserContext)
    const apiInfo = organization_getOrganizationsByUser_Api
    const refreshKey = useMemo(
        () => [apiInfo.path.replace(':id', user?.id)].join('/'),
        [user?.id]
    )
    const [limit, setLimit] = useState(3)

    return (
        <UserOrganizations
            user_id={getId(user)}
            renderWrap={(child, __, count) =>
                count > 0 && (
                    <WrapperBlockSider flat={false} title="you might like">
                        <div className="flex flex-col gap-1">
                            <CustomLazyPaginationWrapper
                                sample={limit}
                                auto={true}
                                key={refreshKey}
                                apiInfo={apiInfo}
                                renderLoading={renderLoading}
                                renderItem={(item) => (
                                    <div
                                        className="px-3 py-2 flex items-center gap-3 hover:background-200 cursor-pointer transition-all duration-300">
                                        <Avatar
                                            size={44}
                                            icon={<BiSolidChurch size={22} className="text-primary-600"/>}
                                            src={getAvatar(item)}
                                            className="flex flex-center bg-primary-50 rounded-xl flex-shrink-0"
                                        />
                                        <div className="flex flex-col flex-1 min-w-0">
                                            <Link
                                                to={getLinkToDetail(item)}
                                                className="font-semibold text-sm no-underline leading-snug truncate">
                                                {getTitle(item)}
                                            </Link>
                                            <OrgType item={item} className="font-bold text-2xs text-blue-500 truncate"/>
                                        </div>
                                        <FollowButton
                                            size="small"
                                            item={item}
                                        />
                                    </div>
                                )}
                                query={bindQueryParam({id: user?.id})}
                                renderLoadMoreButton={
                                    renderShowMore(
                                        [limit, setLimit],
                                        {
                                            buttonClassName: 'my-2 font-medium text-xs text-secondary-500 hover:text-secondary-700'
                                        }
                                    )
                                }
                            />
                        </div>
                    </WrapperBlockSider>
                )
            }
        />
    )
}

export const LivestreamMass = () => {

    const t = useTranslate()
    const {isLoading = false, response: summary} = useAsync({
        apiInfo: channel_getSummaryChannelArticle_Api,
        values: {type: "church-masstime-block"}
    })
    const _data = getResponseItems(summary)
    const blockData = _.find(_data, {id: "church-masstime-block"}) ?? {}
    const {feeds: feedsData = []} = blockData ?? {}
    const hasRealPhoto = (photo) => photo && photo !== ImagePlaceholder && !photo.startsWith('data:image/svg')

    if (isLoading) return renderLoading()

    return (
        <WrapperBlockSider flat={false} icon={<GoDotFill size={16} className="text-primary-700 pulse-live"/>} title="livestream mass">
            <div className="flex flex-col">
                <Toggle>
                    {(isToggle, toggle) => (
                        <>
                            {feedsData.slice(0, isToggle ? feedsData.length : 3).map((e, idx) => {
                                return idx === 0 ? (
                                    <Link
                                        key={idx}
                                        to={getLinkToDetail(e?.content)}
                                        className="px-3 py-2 flex flex-col gap-2 hover:background-200 text-color-000 relative transition-all duration-300 no-underline">
                                        <div className="rounded-xl overflow-hidden relative">
                                            {hasRealPhoto(e?.content?.overview?.photo) ? (
                                                <Image
                                                    src={e?.content?.overview?.photo}
                                                    fallback={ImagePlaceholder}
                                                    style={{height: 160}}
                                                    wrapperClassName="w-full"
                                                    className="object-cover rounded-xl"
                                                    preview={false}
                                                />
                                            ) : (
                                                <ChurchScenePlaceholder height={40} width={40} borderRadius="12px"/>
                                            )}
                                            <div
                                                style={{
                                                    height: '55%',
                                                    background: 'linear-gradient(to top, rgba(0,0,0,0.88) 0%, rgba(0,0,0,0.62) 30%, rgba(0,0,0,0.28) 65%, rgba(0,0,0,0) 100%)',
                                                }}
                                                className="w-full absolute bottom-0 left-0"
                                            />
                                            <span className="absolute bottom-0 m-2 font-bold text-sm text-white hover:text-primary tracking-wide max-lines-2">
                                                {getTitle(e?.content?.overview)}
                                            </span>
                                        </div>
                                    </Link>
                                ) : (
                                    <Link
                                        key={idx}
                                        to={getLinkToDetail(e?.content)}
                                        className="px-3 py-2 flex items-center gap-3 hover:background-200 text-color-000 transition-all duration-300 no-underline">
                                        {hasRealPhoto(e?.content?.overview?.photo) ? (
                                            <Image
                                                src={e?.content?.overview?.photo}
                                                fallback={ImagePlaceholder}
                                                style={{width: 44, height: 44}}
                                                className="object-cover rounded-lg"
                                                preview={false}
                                            />
                                        ) : (
                                            <ChurchScenePlaceholder height={40} width={40} borderRadius="12px"/>
                                        )}
                                        <span className="flex-1 font-semibold tracking-wide leading-snug max-lines-2">
                                            {getTitle(e?.content?.overview)}
                                        </span>
                                    </Link>
                                )
                            })}
                            <div className="my-2 flex justify-end">
                                <div onClick={toggle}
                                     className="py-1 px-3 cursor-pointer font-medium text-xs text-secondary-500 hover:text-secondary-700">
                                    {isToggle ? t('see less') : `${t('show more')}...`}
                                </div>
                            </div>
                        </>
                    )}
                </Toggle>
            </div>
        </WrapperBlockSider>
    )
}

export const GamePromo = () => {

    const [reloadKey, setReloadKey] = useState(0)
    const {response, isLoading} = useAsync({
        apiInfo: game_getPreviewQuestion_Api,
        deps: [reloadKey],
    })
    const preview = _.get(response, 'data.data')

    const reload = useCallback(() => setReloadKey((v) => v + 1), [])

    return (
        <QuizPreviewCard preview={preview} onReload={reload} loading={isLoading}/>
    )
}

const Content = () => {
    const t = useTranslate()
    const {user} = useContext(UserContext)
    const {isLg} = useContext(LayoutContext)
    const shareUrl = `${ROOT_URL}${getLinkToDetail(user)}`

    return (
        <div className="flex flex-col gap-6 mt-6">
            {isLg && (
                <Organizations/>
            )}
            {isLg && (
                <LivestreamMass/>
            )}
            {isLg && (
                <GamePromo/>
            )}
            {/*{isLg && (*/}
            {/*    <NearbyChurches/>*/}
            {/*)}*/}
            {/*{isLg && (*/}
            {/*    <Channels/>*/}
            {/*)}*/}
        </div>
    )
}

const UserSider = ({Wrapper = 'div', stickySider = true}) =>
    createStickySider({
        Wrapper,
        stickySider,
    })(Content)

export default UserSider
